export const version = 'patterns@1.430.0';
